/** L'elenco delle commesse, dal lato della pagina. */
import { get } from './api'
import type { Commessa, Flight, Lifecycle } from './types'

export function commesse(): Promise<Commessa[]> {
  return get<Commessa[]>('/inspections')
}

/** Le sei tappe di un pacchetto, coi loro conti. */
export function lifecycle(inspectionId: string): Promise<Lifecycle> {
  return get<Lifecycle>(`/inspections/${encodeURIComponent(inspectionId)}/lifecycle`)
}

/** Le promesse del volo, misurate con le soglie della consegna (GI-249). */
export function flight(inspectionId: string): Promise<Flight> {
  return get<Flight>(`/inspections/${encodeURIComponent(inspectionId)}/flight`)
}

/** Dove sta ogni commessa, per la mappa del pool (S17, L-4). */
export interface JobGeometry {
  inspection_id: string
  external_inspection_id: number
  lines: [number, number][][]
}

export function geometry(): Promise<JobGeometry[]> {
  return get<JobGeometry[]>('/inspections/geometry')
}
